import React, { useContext, useState } from "react";
import { Dropdown, Stack } from "sprint-common-web";

import {
    DeliveryEndpointType,
    deliveryEndpointTypeDropdownOptions
} from "../../../../../common/types/DeliveryEndpointType";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { useDeliveryEndpointsData } from "../useDeliveryEndpointsData";
import { EditAsperaDeliveryInfoForm } from "./EditAsperaDeliveryInfoForm";
import { EditSigniantDeliveryInfoForm } from "./EditSigniantDeliveryInfoForm";
import { EditSmartjogDeliveryInfoForm } from "./EditSmartjogDeliveryInfoForm";

export interface EditDeliveryInfoFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export const EditDeliveryInfoForm: React.VFC<EditDeliveryInfoFormProps> = ({ onSubmit, onCancel }) => {
    const { getDeliveryEndpoint } = useDeliveryEndpointsData();

    const { systemPlatformDetailsItem } = useContext(SystemPlatformDetailsContext);

    const deliveryEndpoint = systemPlatformDetailsItem.deliveryInfo.deliveryEndpoint
        ? getDeliveryEndpoint(systemPlatformDetailsItem.deliveryInfo.deliveryEndpoint.id)
        : undefined;

    const [selectedType, setSelectedType] = useState<DeliveryEndpointType | undefined>(deliveryEndpoint?.type);

    const handleDeliveryTypeSelected = (type?: string) => {
        setSelectedType(Number(type));
    };

    const getDeliveryEndpointForm = (type?: DeliveryEndpointType): React.ReactNode => {
        switch (type) {
            case DeliveryEndpointType.Aspera: {
                return <EditAsperaDeliveryInfoForm onCancel={onCancel} onSubmit={onSubmit} />;
            }

            case DeliveryEndpointType.Smartjog: {
                return <EditSmartjogDeliveryInfoForm onCancel={onCancel} onSubmit={onSubmit} />;
            }

            case DeliveryEndpointType.Signiant: {
                return <EditSigniantDeliveryInfoForm onCancel={onCancel} onSubmit={onSubmit} />;
            }

            default: {
                return <></>;
            }
        }
    };

    return (
        <Stack>
            <Dropdown
                label="Type"
                selectedKey={selectedType ? selectedType.toString() : undefined}
                options={deliveryEndpointTypeDropdownOptions}
                onChange={handleDeliveryTypeSelected}
            />
            {getDeliveryEndpointForm(selectedType)}
        </Stack>
    );
};
